import registry from "~/components/DoRegistry.js";
import DoAjax from "~/components/ajax/DoAjax.js";
import DoForm from "~/components/forms/DoForm.js";
import template from './create.hbs';

class Page {

    constructor($target, $errorTarget){
        this.$target = $target;
        this.ajax = new DoAjax($errorTarget);
        this.form = new DoForm($target);
    }

    render(url){

        this.url = url;

        let $result = this.ajax.page(this.$target, url);

        $result
            .done((data)=>{
                data.colorWord = window.currentCountryCode === 'CA' ? 'Colour' : 'Color';
                this.$target.html(template(data));
            });

        return $result;
    }

    save(){
        if(!this.validate()) return $.Deferred().reject().promise();

        let data = this.extract();

        let result = this.ajax.ajax(data.id ? "PUT" : "POST", this.url, data, true);

        result.fail(()=>{$('html, body').animate({scrollTop: '0px'}, 300);});

        return result;
    }

    validate(){
        var data = this.extract();
        var result = true;

        if(data.description == ""){
            this.form.markError(this.$target.find('[name=description]'), "Cannot be empty", true);
            result = false;
        }

        let $colors = this.$target.find('[name=label]');
        for(var x in data.iconColors){
            if(data.iconColors[x].label && data.iconColors[x].label.length > 60){
                this.form.markError($($colors.get(x)), "Label name too long.  Max length of "+60+" characters.", true);
                result = false;
            }
        }

        return result;
    }

    //extract the form data
    extract(){
        var result = {
            id : this.$target.find('[name=id]').val(),
            description : this.$target.find('[name=description]').val(),
            iconColors : []
        };
        this.$target.find('.data-row').each(function(){
            let $row = $(this);
            let entry = {
                id : $row.find('[name=id]').val(),
                color : $row.find('[name=color]').val(),
                label: $row.find('[name=label]').val()
            };

            result.iconColors.push(entry);
        });

        return result;
    }
}

registry.register(__filename, Page);
export default Page;